import type { UnitInfoPanFeederInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import type { PanFeederSPUnitInfoDataMapInterface } from './unitInfoData';

export const INCLINATION_OPTIONS = ['4', '8', '12'];

export const filterModels = (
  models: string[],
  mining: boolean,
  ulip: boolean,
): string[] => {
  if (mining && !ulip) {
    return models.filter((m) => m.includes('M') && !m.includes('ULIP'));
  } else if (!mining && ulip) {
    return models.filter((m) => !m.includes('M') && m.includes('ULIP'));
  } else if (mining && ulip) {
    return models.filter((m) => m.includes('M') && m.includes('ULIP'));
  } else {
    return models.filter((m) => !m.includes('M') && !m.includes('ULIP'));
  }
};

export const getDescriptionFromModelName = (
  unitInfoData: PanFeederSPUnitInfoDataMapInterface,
  modelName: string,
): string => {
  return (
    Object.values(unitInfoData).find((model) => model.modelName === modelName)
      ?.descriptiveName ?? ''
  );
};

export const getModelNameFromDescriptive = (
  unitInfoData: PanFeederSPUnitInfoDataMapInterface,
  descriptive: string,
): string => {
  return (
    Object.values(unitInfoData).find(
      (model) => model.descriptiveName === descriptive,
    )?.descriptiveName ?? ''
  );
};

export const getDefaultData = (
  unitInfoData: PanFeederSPUnitInfoDataMapInterface,
): UnitInfoPanFeederInterface => {
  return {
    modelName: Object.values(unitInfoData)[28].modelName,
    moisture: 0,
    newMoisture: false,
    mining: false,
    ulip: false,
    inclination: 8,
    autoSelect: false,
    parallelUnits: 1,
    otherModel: false,
    otherModelMaxCapacity: 0,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayInclination: false,
      displayLoad: true,
      displayNominalCapacityRange: false,
    },
  };
};

export class PanFeederSPConfig extends BaseUnitConfig {
  static getDefaultData(params?: UnitConfigParams): UnitInfoPanFeederInterface {
    const unitInfoData = params?.data as PanFeederSPUnitInfoDataMapInterface;

    return {
      modelName: Object.values(unitInfoData)[28].modelName,
      ...BaseUnitConfig.getBaseDefaults(),
      mining: false,
      ulip: false,
      inclination: 8,
      autoSelect: false,
      otherModel: false,
      otherModelMaxCapacity: 0,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayInclination: false,
        displayLoad: true,
        displayNominalCapacityRange: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const panFeederSPConfig = new PanFeederSPConfig();
